export class AbsenceDeservedDto {
    id: number;
    employeeId: number;
    absenceType: number;
    unitOfInterval: string;
    deservedAmount: number;
    transferAmount: number;
    remainingAmount: number;
    startDate: string;
    endDate: string;
    totalUsedAbsenceAmount: number;

    constructor() {
        this.deservedAmount = 0;
        this.transferAmount = 0;
        this.remainingAmount = 0;
    }
}
